import { createDCHook, collapseDataFromCall } from '../client';
import { getDynamicPricesPublic } from '../services/UsageDynamicPricePublicService';

export const useUsageDynamicPricePublicGetDynamicPricesPublic = createDCHook(
  'getDynamicPricesPublic',
  collapseDataFromCall(getDynamicPricesPublic),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
